module.exports = __webpack_public_path__ + "static/media/id.a5b8d99b.svg";